import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import {token, domain} from '../Security';
import jsPDF from "jspdf";
import loadingSpinner from './../../assets/loading.gif';

function BankTransmittalChinaBank({isHideSideMenu}) {
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [classificationId, setClassificationId] = useState("");
    const [departmentId, setDepartmentId] = useState("");
    const [company, setCompany] = useState([]);
    const [locationId, setLocationId] = useState("");
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);

    const downloadPDF = useCallback(async (data) => {
        // Create a new jsPDF instance
        const _doc = new jsPDF();

        const drawLine = (doc, lineX, lineY) => {
            const startX = lineX;
            const endX = doc.internal.pageSize.getWidth() - 10; // Width of page minus some margin
            const startY = lineY;
            doc.line(startX, startY, endX, startY);
        };
        const title = (doc, title, titleX, titleY) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(14);
            // doc.setTextColor("#668fca");
            doc.setLineWidth(0.5);
            doc.text(title, titleX, titleY);
        }
        const header = (doc, title, titleX, titleY) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            // doc.setTextColor("#668fca");
            doc.setLineWidth(0.5);
            doc.text(title, titleX, titleY);
        }
        const info = (doc, label, labelX, labelY) =>{
            doc.setFont("helvetica", "normal");
            doc.setFontSize(9);
            doc.text(label, labelX, labelY); 
        }
        const infoWithValue = (doc, label, labelX, labelY, value, valueX, valueY, maxWidth) =>{
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            // doc.setTextColor("#668fca");
            doc.text(label, labelX, labelY); 
            doc.setFont("helvetica", "normal");
            // doc.setTextColor("#686868");
            const splitText = doc.splitTextToSize(value, maxWidth); // Split the text into lines based on maxWidth
            doc.text(splitText, valueX, valueY);
        }
        function formatDate(dateStr) {
            const date = new Date(dateStr);
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
            const formattedDate = date.toLocaleDateString("en-US", options);
            return formattedDate;
        }
        const formatTime = (dateTimeStr) => {
            const date = new Date(dateTimeStr);
            const formattedTime = date.toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            });
            return formattedTime;
        };
        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };
        const formatName = (name) => {
            if(name){
                const nameParts = name.split(", ");
                const formattedName = nameParts.map(part => {
                    return part.split('-').map(subPart => 
                        subPart.charAt(0).toUpperCase() + subPart.slice(1).toLowerCase()
                    ).join('-');
                }).join(", ");
    
                return formattedName.replace(/\b\w/g, (match) => match.toUpperCase());
            }
            return "";
        };

        const halfPageWidth = _doc.internal.pageSize.getWidth() / 2;
        const secondInfoX = halfPageWidth + 5;
        
        title(_doc, `Bank Transmittal China Bank Savings`, 65, 10);

        infoWithValue(_doc, "Run By: ", 10, 20, "test_dummy@gmail.com", 40, 20);
        infoWithValue(_doc, "Report Id: ", 10, 25, (1).toString(), 40, 25);
        infoWithValue(_doc, "Credit Date From: ", 10, 30, formatDate(dateFrom), 40, 30);
        infoWithValue(_doc, "Credit Date To: ", 10, 35, formatDate(dateTo), 40, 35);

        header(_doc, `Company Credit`, 10, 45);
        info(_doc, `${formatDate(new Date())} ${formatTime(new Date())}`, 10, 50);

        header(_doc, `Transaction Prooflist`, 10, 60);
        infoWithValue(_doc, "Client Name: ", 10, 70, "", 40, 70);
        infoWithValue(_doc, "User Name: ", 10, 75, "", 40, 75);
        infoWithValue(_doc, "Batch Number: ", 10, 80, "", 40, 80);
        infoWithValue(_doc, "Ceiling Amount: ", secondInfoX, 70, numberWithCommasAndDecimal(0), secondInfoX + 40, 70);
        infoWithValue(_doc, "No. of Records: ", secondInfoX, 75, data.length, secondInfoX + 40, 75);
        infoWithValue(_doc, "Batch Amount: ", secondInfoX, 80, numberWithCommasAndDecimal(0), secondInfoX + 40, 80);

        drawLine(_doc, 10, 90);
        header(_doc, `Rec. No.`, 10, 95);
        header(_doc, `Employee Account No.`, 35, 95);
        header(_doc, `Employee Name`, 85, 95);
        header(_doc, `Credit Date`, 130, 95);
        header(_doc, `Amount`, 170, 95);
        drawLine(_doc, 10, 97.5);

        // Add data here
        let y = 102.5; // Starting Y position for data
        const pageHeight = _doc.internal.pageSize.getHeight();
        const threshold = pageHeight - 20; 

        let totalAmount = 0;

        data.forEach((employee, index) => {
            if (y > threshold) {
                _doc.addPage(); // Add new page
                y = 20;
            }

            const amount = 0;

            info(_doc, (index + 1).toString(), 11, y);
            info(_doc, employee.employeeBankAccount[0] ? employee.employeeBankAccount[0].bankAccount : "", 36, y);
            info(_doc, formatName(employee.fullName), 86, y);
            info(_doc, formatDate(new Date()), 131, y);
            info(_doc, numberWithCommasAndDecimal(amount), 170, y);

            totalAmount += amount;
            y += 5; // Increment Y position for next row
        });

        drawLine(_doc, 10, y);
        infoWithValue(_doc, "Total Amount: ", 140, y + 10, numberWithCommasAndDecimal(totalAmount), 170, y + 10);


        // Save the PDF
        _doc.save(`Bank_Transmittal_China_Bank_Savings.pdf`);
    }, [dateFrom, dateTo]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            const classificationIdNumber = Number(classificationId);
            const departmentIdNumber = Number(departmentId);
            const companyIdNumber = Number(company.id);
            const locationIdNumber = Number(locationId);

            const sortedData = response.data
                .filter(data => (data.employeeInformation?.classificationId ?? null) === classificationIdNumber)
                .filter(data => (data.employeeInformation?.departmentId ?? null) === departmentIdNumber)
                .filter(data => (data.employeeInformation?.companyId ?? null) === companyIdNumber)
                .filter(data => (data.employeeInformation?.locationId ?? null) === locationIdNumber);
                
            /* const dataWithBankAccount = sortedData.filter(data => {
                const bankAccount = data.employeeBankAccount[0];
                return bankAccount !== null && bankAccount !== undefined && bankAccount !== "";
            });
            const finalData = dataWithBankAccount; */
            downloadPDF(sortedData);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [downloadPDF, classificationId, company, departmentId, locationId]);

    const generate = () =>{
        if(!dateFrom
            || !dateTo
            || !classificationId
            || !departmentId
            || !company
            || !locationId
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo shadow-xl">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Bank Transmittal China Bank Savings"}</span>
                            </div>
                            <h3>Generate Bank Transmittal China Bank Savings Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Date From</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={dateFrom} setDate={setDateFrom}/>
                                    </div>
                                    <span style={{
                                                visibility: !dateFrom && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Date To</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={dateTo} setDate={setDateTo}/>
                                    </div>
                                    <span style={{
                                                visibility: !dateTo && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Classification</div>
                                    <div className="info-item-input">
                                        <ClassificationIdSelect classificationId={classificationId} setClassificationId={setClassificationId}/>
                                    </div>
                                    <span style={{
                                                visibility: !classificationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="info-item-holder row">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Department</div>
                                    <div className="info-item-input">
                                        <DepartmentIdSelect departmentId={departmentId} setDepartmentId={setDepartmentId}/>
                                    </div>
                                    <span style={{
                                                visibility: !departmentId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect company={company} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !company && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Location</div>
                                    <div className="info-item-input">
                                        <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                                    </div>
                                    <span style={{
                                                visibility: !locationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="activeEmployeesGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function ClassificationIdSelect({classificationId, setClassificationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function DepartmentIdSelect({departmentId, setDepartmentId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDepartmentId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Department/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(departmentId !== "" && departmentId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [departmentId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={departmentId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose department</option>
            {data.map((departmentId) => ( 
                SetDepartmentId(departmentId)
            ))}
            </select>
        </div>
    );
    };
function SetDepartmentId(departmentId){
    return(
        <option value={departmentId.id}>{
            departmentId.description}
        </option>
    )
}
function CompanyTypeSelect({company, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
            setIsSelected(true);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (company !== "" && company !== 0 && company !== null && company !== undefined && company.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [company]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={company} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((company) => ( 
                SetCompanyType(company)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(company){
    return(
        <option value={company.id}>{
            company.name}
        </option>
    )

}
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}

export default BankTransmittalChinaBank
